import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { EmailService } from '../../../../../../_services/email/email.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { Router , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-billing-comment',
  templateUrl: './billing-comment.component.html',
})
export class BillingCommentComponent implements OnInit {
  @Output() hideModalOutput: EventEmitter<boolean> = new EventEmitter();
  @Input() commentType: string;
  @Input() policy:any;
  thanksMessage: string;
  copyToYourEmailMessage: string;
  emailAddress: string;
  billingCommentModal: ModalOptions;
  hideModal: boolean;
  isAcmic = false;

  constructor(
    private storageService: StorageServiceObservablesService,
    private acmicService: AcmicService,
    private emailService: EmailService,
    private router:Router
  ) {
    this.emailAddress = this.storageService.getUserFromStorage();
    this.thanksMessage = 'BILLING_COMMENT_THANKS_FOR_REQUEST';
    this.copyToYourEmailMessage = 'BILLING_COMMENT_PARAGRAPH_ONE';
    this.billingCommentModal = new ModalOptions({
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'billingCommentModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalName: 'billing_Comment',
    });
  }

  resetHideModal(): void {
    this.hideModal = false;
    this.hideModalOutput.emit(this.hideModal);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    if(this.commentType && this.commentType === "Other request"){
      this.thanksMessage = 'THANKS_SEND_MESSAGE';
      this.copyToYourEmailMessage = 'COPY_TO_YOUR_EMAIL'
      this.emailAddress = this.storageService.getUserFromStorage();
    }
  }

  onClickBack() {
    if(this.commentType){
      this.router.navigate(['/billing-new/'+ this.policy?.policynumber?.policyNumber +'/details'])
    }else{
      this.hideModal = !this.hideModal;
      this.hideModalOutput.emit(this.hideModal);
    }

  }
}
